// Validação tipada de variáveis de ambiente usando Zod
import { z } from 'zod';

// Define apenas as variáveis que a aplicação consome explicitamente
const schema = z.object({
  VITE_SENTRY_DSN: z
    .string()
    .refine(
      (val) => {
        if (!val) return true; // Permite valor vazio se for opcional
        try {
          new URL(val);
          return true;
        } catch {
          return false;
        }
      },
      { message: 'VITE_SENTRY_DSN deve ser uma URL válida' }
    )
    .optional(),
});

// Extrai somente as chaves esperadas para evitar ruído do objeto import.meta.env completo
const raw = {
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
};

export const env = schema.parse(raw);
export type Env = typeof env;

// Helper para exigir variável em runtime (ex: produção)
export function requireEnv<K extends keyof Env>(key: K): NonNullable<Env[K]> {
  const value = env[key];
  if (value == null || value === '') {
    throw new Error(`Variável de ambiente ausente: ${key}`);
  }
  return value;
}
